import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { BsFillCircleFill } from 'react-icons/bs'
import * as S from "./styles"
import { useTranslation } from 'react-i18next'

const HistoryInformation = ({ data, status }) => {
    const { t } = useTranslation()
    const [historyItems, setHistoryItems] = useState([])
    const historyInform = [
        {
            "status": 0,
            "data": "",
            "usuario": ""
        },
        {
            "status": 1,
            "data": "",
            "usuario": ""
        },
        {
            "status": 2,
            "data": "",
            "usuario": ""
        },
        {
            "status": 3,
            "data": "",
            "usuario": ""
        },
        {
            "status": 4,
            "data": "",
            "usuario": ""
        },
        {
            "status": 5,
            "data": "",
            "usuario": ""
        },
        {
            "status": 6,
            "data": "",
            "usuario": ""
        },
        {
            "status": 7,
            "data": "",
            "usuario": ""
        },
        {
            "status": 9,
            "data": "",
            "usuario": ""
        }
    ]

    useEffect(() => {
        const lastStatus = data[data.length - 1].status
        const filteredTimeline = historyInform.filter((item) => item.status > Number(lastStatus))

        setHistoryItems([...data, ...filteredTimeline])

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    return (
        <S.Wrapper>
            <S.Container>
                <S.Content>
                    {
                        historyItems.length > 0 && (
                            <>
                                <div id="circle-container">
                                    <BsFillCircleFill size={64} color="#6a5cff" />
                                </div>
                                <S.TimelineDash itemsQuantity={historyItems.length} />
                            </>
                        )
                    }
                    {
                        historyItems.map((item, index) => {
                            const isLastItem = index === historyItems.length - 1
                            return (
                                <React.Fragment key={index}>
                                    <S.TimelineItem disabled={item.data === ''}>
                                        <S.TimelineItemDetails isEven={index % 2 === 0} disabled={item.data === ''}>
                                            <div className='timeline-item-text' title={t(`transport.status.${item.status}`)}>{t(`transport.status.${item.status}`)}</div>
                                            {
                                                item.status === '7' && item.description !== t(`transport.status.${item.status}`) ?
                                                    <small style={{ color: '#6a5cff' }}>{item.description}</small>
                                                    : null
                                            }
                                            {item.data ?
                                                <div className='timeline-item-bottom'>
                                                    <small>
                                                        {item.usuario}
                                                    </small>
                                                    <small>
                                                        {moment(item.data).utc().format('L')}
                                                    </small>
                                                </div>
                                                : null
                                            }
                                        </S.TimelineItemDetails>
                                        {item.data ?
                                            <span>{moment(item.data).utc().format('L')}</span>
                                            : <BsFillCircleFill size={25} color="lightGray" />
                                        }
                                    </S.TimelineItem>
                                    {!isLastItem && (<S.TimelineDash />)}
                                </React.Fragment>
                            )
                        })
                    }
                </S.Content>
            </S.Container>
        </S.Wrapper>
    )
}

export default HistoryInformation